import { createContext, useContext } from "react";
import type { CSSProperties } from "react";

export type ListVirtualItem = {
  index: number;
  start: number;
  size: number;
  measure: (node: Element | null) => void;
};

// Set by ListVirtualized around each rendered row, so an item deep in the
// render prop positions itself without the caller wiring transforms by hand.

export const ListVirtualItemContext = createContext<ListVirtualItem | null>(
  null,
);

export function useListVirtualItem(): ListVirtualItem | null {
  return useContext(ListVirtualItemContext);
}

export function virtualItemStyle(
  item: ListVirtualItem | null,
): CSSProperties | undefined {
  if (!item) {
    return undefined;
  }

  return {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    transform: `translateY(${item.start}px)`,
  };
}
